import {
  Component,
  OnInit,
  ViewChildren,
  QueryList,
  AfterViewInit,
} from "@angular/core";
import { first } from "rxjs/operators";
import { Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgbdSortableHeader } from "src/app/shared/directives/sortable.directive";
import { SortEvent } from "src/app/shared/directives/sort-event.interface";
import { CorrectionHistory } from "src/app/mon-portefeuille/core/model/correction-history";
import { CorporateService } from "../../core/service/corporate.service";
import { CorrectionHistoryService } from "src/app/mon-portefeuille/core/service/correction-history.service";
import { AnnulerCorrection } from "src/app/mon-portefeuille/core/model/annuler-correction";
import { FormulaireService } from "src/app/parametrage/core/service/formulaire.service";
import { FormulaireDTO } from "src/app/parametrage/core/model/formulaire-dto";
import { KeycloakService } from "src/app/core/services/auth/keycloak.service";
import { UserService } from "src/app/shared/directives/user.service";

export const compare = (v1, v2) => (v1 < v2 ? -1 : v1 > v2 ? 1 : 0);

@Component({
  selector: "app-en-correction",
  templateUrl: "./en-correction.component.html",
  styleUrls: ["./en-correction.component.scss"],
})
export class EnCorrectionComponent implements AfterViewInit {
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

  page: number = 0;
  totalElements: number = 0;
  filter: String = "";
  sort: SortEvent = { column: "id", direction: "desc" };

  MyPermissions: string[];

  private userPermission = {
    permissions: [],
  };

  corrections: CorrectionHistory[];

  isLoadingResults = true;

  annulerCorrection: AnnulerCorrection;
  formulaire: FormulaireDTO;

  constructor(
    private _router: Router,
    private modalService: NgbModal,
    private userService: UserService,
    private _corporateService: CorporateService,
    private _correctionHistoryService: CorrectionHistoryService,
    private _formulaireService: FormulaireService,
    private _keycloakService: KeycloakService
  ) {
    this.MyPermissions = _keycloakService.getAccessPermissions();
    this.userPermission.permissions = this.MyPermissions;
    this.userService.setUser(this.userPermission);
  }

  ngAfterViewInit() {
    this.getAllCorrectionHistorique("_", this.page, this.sort);
  }

  getAllCorrectionHistorique(
    filter: String,
    pageIndex: number,
    sort: SortEvent
  ): CorrectionHistory[] {
    this.isLoadingResults = true;

    this._corporateService
      .findAllDossierAcorriger(
        filter,
        pageIndex,
        5,
        sort.column,
        sort.direction
      )
      .subscribe(
        (data) => {
          this.isLoadingResults = false;

          this.corrections = data.content;
          this.totalElements = data.totalElements;

          return this.corrections;
        },
        (error) => {
          console.log(error);
          this.isLoadingResults = false;
        }
      );

    return null;
  }

  onSort({ column, direction }: SortEvent) {
    this.sort.column = column;
    this.sort.direction = direction;

    // resetting other headers
    this.headers.forEach((header) => {
      if (header.sortable !== column) {
        header.direction = "";
      }
    });

    // sorting
    if (direction === "") {
      this.page = 0;
      this.corrections = this.getAllCorrectionHistorique(
        this.filter,
        this.page,
        this.sort
      );
    } else {
      this.page = 0;
      this.corrections = [
        ...this.getAllCorrectionHistorique(this.filter, this.page, this.sort),
      ].sort((a, b) => {
        const res = compare(a[column], b[column]);
        return direction === "asc" ? res : -res;
      });
    }
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.filter = filterValue;
    this.page = 0;
    this.getAllCorrectionHistorique(this.filter, this.page, this.sort);
  }

  loadPage(page: number): void {
    page = page - 1;
    this.getAllCorrectionHistorique(this.filter, page, this.sort);
  }

  dossierInfo(requestId) {
    this._formulaireService.takeFormInfoRequest(requestId).subscribe(
      (data) => {
        this.formulaire = data;
        this._router.navigateByUrl(this.formulaire.url);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  annuler(correctionId): void {
    this.annulerCorrection = new AnnulerCorrection();
    this.annulerCorrection.correctionId = correctionId;
    this._correctionHistoryService
      .annuler(this.annulerCorrection)
      .pipe(first())
      .subscribe(
        (data) => {
          this.page = 0;
          this.getAllCorrectionHistorique("_", this.page, this.sort);
        },
        (error) => {
          console.log(error);
        }
      );
  }
}
